/*
*
* File JS per la STADIO PAGE
*
*/

import ScrollMagic from 'ScrollMagic';

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import cardNews from '../../components/cards/card-news';
import pagination from '../../components/pagination/pagination';
import archiveFilters from '../../components/archive-filters/archive-filters';
import blockNewsMedia from '../../components/block-news-media/block-news-media';
import banner from '../../components/banner/banner';
import bannerWide from '../../components/banner_wide/banner_wide';
import blockVideo from '../../components/block-video/block-video';
import gallery from '../../components/block-gallery/block-gallery';
import blockApp from '../../components/block-app/block-app';
import accordion from '../../components/block-accordion/accordion';
import download_cta from '../../components/block-download-cta/download_cta';
import download_cta__inline from '../../components/block-download-cta-inline/download_cta_inline';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './stadio.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

var controller = new ScrollMagic.Controller();


if (jQuery(".sectionmoment").length > 0) {
    var slides = document.querySelectorAll(".cards-momenti");

    // create scene for every slide
    for (var i = 0; i < slides.length; i++) {
      new ScrollMagic.Scene({
        triggerElement: slides[i],
      })
        .setClassToggle(slides[i], "open_section")
        .addTo(controller);
    }
  }

//--------------------------------------------------------------------//